(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pdp-voice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pdp-accordion')) {
    class PdpAccordion extends HTMLElement {
      connectedCallback() {
        this.onProductSelect = this.onProductSelect.bind(this);
        this.section = this.closest('.shopify-section, dialog');
        this.section?.addEventListener('shopify:product:select', this.onProductSelect);
      }

      disconnectedCallback() {
        this.section?.removeEventListener('shopify:product:select', this.onProductSelect);
      }

      onProductSelect(event) {
        if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
        if (!event.promise || typeof event.promise.then !== 'function') return;

        event.promise
          .then((result) => {
            const detail = result && result.detail;
            if (!detail?.html) return;

            if (detail.newProduct?.id) {
              this.dataset.productId = String(detail.newProduct.id);
            } else if (detail.productId && String(detail.productId) !== this.dataset.productId) {
              return;
            }

            const blockId = this.dataset.blockId;
            const next = blockId
              ? detail.html.querySelector(`pdp-accordion[data-block-id="${CSS.escape(blockId)}"]`)
              : detail.html.querySelector('pdp-accordion');

            if (!next) {
              this.hidden = true;
              this.replaceChildren();
              return;
            }

            const openRows = new Set();
            this.querySelectorAll('details[open]').forEach((row) => {
              const key = row.getAttribute('data-row');
              if (key) openRows.add(key);
            });

            this.innerHTML = next.innerHTML;
            this.hidden = next.hasAttribute('hidden');
            this.querySelectorAll('details').forEach((row) => {
              const key = row.getAttribute('data-row');
              if (key && openRows.has(key)) row.open = true;
            });
          })
          .catch((error) => {
            if (error?.name !== 'AbortError') console.warn('[pdp-accordion] variant update failed', error);
          });
      }
    }

    customElements.define('pdp-accordion', PdpAccordion);
  }
  } catch(e) { console.error(e); }
})();

})();
